import { Component, OnInit } from '@angular/core';
import { CategoriesService } from 'src/app/services/categoriesService/categories.service';
import { UserService } from 'src/app/services/userService/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-categories-menu',
  templateUrl: './categories-menu.component.html',
  styleUrls: ['./categories-menu.component.less']
})
export class CategoriesMenuComponent implements OnInit {
  type: Number = environment.features.navType;
  openCategories: Boolean = false;
  categories;

  constructor(private categoriesService: CategoriesService, private userService: UserService) { }

  /** Initialize component */
  ngOnInit(): void {
    this.getCategories();

    this.userService.getLoggedInStatus.subscribe(resp => {
      this.getCategories();
    });
  }

  /** Get available categories */
  getCategories() {
    if (this.userService.getUser()) {
      this.categoriesService.getCategories().then((resp: any) => {
        this.categories = resp.data.categoriesTree;
        this.categoriesService.setCategories(this.categories);
      });
    } else {
      this.categories = null;
    }
  }

  /** Closes navigation when the user click on a link */
  closeNav() {
    const self = this;
    setTimeout(function () {
      self.openCategories = false;
    }, 100);
  }
}